import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import InventoryItem from 'components/Profile/components/ProfileInventoryItem';

export function InventoryGroup(props) {
  const {
    data,
    hideHeadings,
    overrideLevels,
    profile,
  } = props;

  const inventoryItems = [...data.possessions]
    .map(item => (
      <InventoryItem
        key={item.id}
        data={item}
        overrideLevels={overrideLevels}
        profile={profile}
      />
    ));

  if (!inventoryItems.length) {
    return null;
  }

  return (
    <div
      className={classnames('inventory-group', profile && 'inventory-group--profile')}
      data-group-name={data.name}
    >
      {!hideHeadings && <h2 className="heading heading--2 inventory-group__heading">{data.name}</h2>}
      <ul className={classnames(
        'items items--inline inventory-group__items',
        profile && 'inventory-group__items--profile',
      )}
      >
        {inventoryItems}
      </ul>
    </div>
  );
}

InventoryGroup.displayName = 'InventoryGroup';

InventoryGroup.propTypes = {
  data: PropTypes.shape({}).isRequired,
  hideHeadings: PropTypes.bool,
  overrideLevels: PropTypes.bool,
  profile: PropTypes.bool,
};

InventoryGroup.defaultProps = {
  hideHeadings: false,
  overrideLevels: false,
  profile: false,
};

export default InventoryGroup;